module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing_2_LV-5f8c1bf7c48d9b8f6bf2f85464194a55.svg";